<template>
    <div>
        <v-row>
            <v-col cols="6">
                <h1 class="headline font-weight-light mb-3">
                    <router-link class="link-a" :to="'/Inventory/Issue'">
                        View DocumentLogistic</router-link
                    >
                    / PRINT
                </h1>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="6" class="text-right">
                <v-btn rounded small @click="print()">
                    <v-icon class="mr-1" dark small>mdi-printer</v-icon>
                    Print</v-btn
                >
            </v-col>
        </v-row>
        <div id="printDiv">
            <!-- ที่เขียน inline เพราะ css ไม่ยอมทำงานตอนปริ้น -->
            <div class="page subpage">
                <div style="width: 100%">
                    <table
                        id=""
                        cellpadding="0"
                        cellspacing="0"
                        style="border-collapse: collapse"
                        border="0"
                        width="100%"
                    >
                        <tr>
                            <th
                                width="30%"
                                align="left"
                                v-if="this.$route.params.company == 'ACACIA'"
                            >
                                <img
                                    src="../../assets/logistic/Acacia.jpg"
                                    width="30%"
                                />
                            </th>
                            <th
                                width="30%"
                                align="left"
                                v-if="this.$route.params.company == 'ASERVE'"
                            >
                                <img
                                    src="../../assets/logistic/aserveicon.png"
                                    width="30%"
                                />
                            </th>
                            <th width="40%" style="padding-left: 170px">
                                <qr-code
                                    style="padding-left: 170px"
                                    text="https://aitt.netlify.app/"
                                    size="75"
                                    color="#021778"
                                    error-level="H"
                                >
                                </qr-code>
                            </th>
                            <th width="30%" align="left">
                                <img
                                    src="../../assets/logistic/Logistics.png"
                                    width="100%"
                                />
                            </th>
                        </tr>
                    </table>

                    <br />

                    <table
                        id=""
                        cellpadding="0"
                        cellspacing="0"
                        style="border-collapse: collapse"
                        border="0"
                        width="100%"
                    >
                        <tr>
                            <td width="50%">
                                <h2>ใบส่งสินค้า (Packing List)</h2>
                            </td>
                            <td>
                                <b style="color: black">Bill No</b> :
                                {{ data_print.consignment_no }}
                            </td>
                        </tr>
                        <tr>
                            <td width="50%">
                                <b style="color: black">ใบส่งสินค้าเลขที่</b> :
                                {{ data_print.packing_no }}
                            </td>
                            <td>
                                <b style="color: black">วันที่ส่ง</b> :
                                {{ data_print.packing_at }}
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <b style="color: black">ส่งจาก</b> :
                                {{ data_print.from_branch_name }}
                            </td>
                            <td>
                                <b style="color: black">ส่งถึง</b> :
                                {{ data_print.to_branch_name }}
                                <b style="color: black">( Totalbox </b>:
                                {{ data_print.total_box
                                }}<b style="color: black">)</b>
                            </td>
                        </tr>
                    </table>

                    <br />
                    <table
                        id=""
                        cellpadding="0"
                        cellspacing="0"
                        style="border-collapse: collapse"
                        border="1"
                        width="100%"
                    >
                        <tr
                            bgcolor="#9eb6e5"
                            style="color: black; font-weight: bold"
                        >
                            <td align="center" height="25px">No</td>
                            <td align="center">Project</td>
                            <td align="center">Case ID</td>
                            <td align="center">Type</td>
                            <td align="center">Description</td>
                            <td align="center">Singlepart</td>
                            <td align="center">S/N</td>
                            <td align="center">Qty</td>
                            <td align="center">Remark</td>
                        </tr>
                        <tr
                            v-for="(dataprintpacking, i) in data_print.packing"
                            :key="i"
                        >
                            <td align="center" height="25px">{{ i + 1 }}</td>
                            <td align="center">
                                {{ dataprintpacking.project_name }}
                            </td>
                            <td align="center">
                                {{ dataprintpacking.case_id }}
                            </td>
                            <td align="center">
                                {{ dataprintpacking.type_name }}
                            </td>
                            <td>{{ dataprintpacking.description }}</td>
                            <td align="center">
                                {{ dataprintpacking.singlepart }}
                            </td>
                            <td align="center">
                                {{ dataprintpacking.serial }}
                            </td>
                            <td align="center">{{ dataprintpacking.qty }}</td>
                            <td>{{ dataprintpacking.remark }}</td>
                        </tr>

                        <tr bgcolor="#9eb6e5">
                            <td align="center" height="25px"></td>
                            <td align="center"></td>
                            <td align="center"></td>
                            <td align="center"></td>
                            <td></td>
                            <td></td>
                            <td align="center">Total</td>
                            <td align="center">{{ this.total }}</td>
                            <td></td>
                        </tr>
                    </table>

                    <br />
                    <table
                        id=""
                        cellpadding="0"
                        cellspacing="0"
                        style="border-collapse: collapse"
                        border="0"
                        width="100%"
                    >
                        <tr>
                            <td height="30" width="75%" align="right">
                                ผู้ส่ง :
                            </td>
                            <td
                                width="25%"
                                style="border-bottom: 1px solid black"
                            ></td>
                        </tr>
                        <tr style="text-align: right">
                            <td style="text-align: right"></td>
                            <td style="text-align: center">
                                <br />
                                {{ data_print.packing_name }}
                            </td>
                        </tr>
                        <tr>
                            <td height="30"></td>
                            <td align="center"></td>
                        </tr>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios"

import { mapState, mapMutations } from "vuex"
import VueHtmlToPaper from "vue-html-to-paper"

const options = {
    name: "_blank",
    specs: ["fullscreen=no", "titlebar=no", "scrollbars=no"],
    styles: [
        "https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css",
        "https://unpkg.com/kidlat-css/css/kidlat.css",
    ],
}

export default {
    mounted() {
        this.getDetail()
    },
    ...mapMutations(["mutateMiniSidebar"]),
    methods: {
        print() {
            this.$htmlToPaper("printDiv")
        },
        async getDetail() {
            const url = `${process.env.VUE_APP_ROOT_API}/api/logistics/packinglist/view/${this.$route.params.packingno}`
            // console.log(url, "urlprint");
            try {
                const { data } = await axios.get(`${url}`)
                // console.log(data, "-data")
                this.data_print = data
                data["packing"].map((each) => {
                    this.total += parseInt(each.qty)
                })
                // console.log(data, "print");
                // console.log(this.total, "total");
            } catch (error) {
                console.log(error)
            }
        },
    },
    data() {
        return {
            data_print: [],
            data_case: [],
            total: 0,
        }
    },
}
</script>
<style scoped>
.spacing-playground .v-select .v-input__prepend-outer,
.spacing-playground .v-select .v-input__append-outer {
    margin-top: 0.55rem;
    margin-right: 0.2rem;
}
body {
    margin: 0 !important;
}
</style>
